import { Context, context, isSpanContextValid, SpanContext, trace } from "@opentelemetry/api";

// Held outside Angular so console capture, which runs before the injector exists, can correlate with it.
let navigationSpanContext: SpanContext | null = null;

export const setNavigationSpanContext = (spanContext: SpanContext | null): void => {
  navigationSpanContext = spanContext;
};

/** Correlates a record with the current page's navigation, unless a valid span is already active; kept after NavigationEnd because errors happen later. */
export const navigationContext = (): Context | undefined => {
  const active: SpanContext | undefined = trace.getSpanContext(context.active());
  if ((active && isSpanContextValid(active)) || !navigationSpanContext || !isSpanContextValid(navigationSpanContext)) {
    return undefined;
  }

  return trace.setSpanContext(context.active(), navigationSpanContext);
};
